<template lang='pug'>
#login-component.container-fluid
  .center-div
    form(@submit.prevent='do_login')
      .form-group
        div
          img.logo(src="login/rinble_logo_high_resolution.png" style='width:320px')
      .form-group
        input.form-control(type='text' placeholder='Username' v-model='username_field' autocapitalize="none")
        // small.form-text.text-muted We'll never share your email with anyone else.
      .form-group
        input.form-control(type="password" placeholder="Password" v-model='password_field')
      .form-group(v-if='!loggingIn')
        button.btn.btn-primary.form-control(:disabled='!username_field || !password_field') Login
      .form-group(v-if='loggingIn')
        .progress(style='height:38px')
          .progress-bar.progress-bar-striped.progress-bar-animated(style='width:100%')
      .form-group(v-if='errormessage')
        .alert.alert-danger {{ errormessage }}
      .form-group
        // reset password button
        a(@click='show_emailreset=true' style='color: grey') forgot password
    form(v-if='show_emailreset' @submit.prevent='do_emailreset')
      .form-group
        input.form-control(type='email' name='email' v-model='email' placeholder='Email')
      .form-group
        button.btn.btn-primary.form-control(name='reset') Reset Password
      .form-group
        div(v-if='show_checkemail')
          span.blabla(style='color: grey') An email has been sent with instructions on resetting your password.

</template>

<style scoped>
#login-component {
  background: #234;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1;
}

video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
}

.center-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  text-align: center;
}

.logo {
  max-width:100%;
  padding: 10px 0px;
}

#error {
  text-align: center;
  position: absolute;
  background: red;
  width:100vw;
  color: white;
  left: 0;
  bottom: 0;
}
</style>

<script >
export default {
  data: function() {
    return {
      username_field: '',
      password_field: '',
      errormessage: '',
      show_emailreset: false,
      email: '',
      show_checkemail: false,
      loggingIn: false,
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    do_emailreset: function() {
      let myEmail=encodeURI(this.email);
      let myToken=encodeURI('eklej4848432kss@.2493222-e373@11!76645448');
      this.$http
      .get(`${global.apiurl}/user/anonpasswordreset&pToken=${myToken}&email=${myEmail}`)
      .then(() => {
        this.show_checkemail=true;
      })
      .catch( err => {
        this.error = err.toString();
      });

      return false;

    },
     
    do_login: async function() {
      let self = this;
      // clear any previous error messages
      this.errormessage = null;

      // update login status
      this.loggingIn = true;

      // dispatch a login
      await this.$store.dispatch(
        'login', { 
          username: this.username_field, 
          password: this.password_field,
      })

      // we're done, so update the login status
      this.loggingIn = false;

      // if we're not logged in at this point, we should set a login error message
      if (this.$store.user === null || this.$store.user === undefined) {
        
        // sometimes we get here but really store.user is coming in a second.
        setTimeout(function() {
          self.errormessage = 'Login failed. Please try again.'
        }, 1500);
        
        // sometimes we get here even though we are logging in
        // this next line won't hurt either way and just makes sure
        // we get to the dialer or messages screen
        setTimeout(function() { self.$router.push('/')}, 1000);

      } else {
        console.log('redirecting to /');
        this.$router.push('/');
      }
        
    },
  },
}
</script>
